import { Stack } from "@mui/material";
import { Icon } from "Components/Shared/Challenge/CardChallenge/Icon";
import { Title } from "Components/Shared/Challenge/CardChallenge/Title";
import { Description } from "Components/Shared/Challenge/CardChallenge/Description";
import { Points } from "Components/Shared/Challenge/CardChallenge/Points";
import { Progress } from "Components/Shared/Challenge/CardChallenge/Progress";
import {
  type LoyaltyEventCode,
  LoyaltyPointType,
} from "Infrastructure/Api/Api";
import { EVENT_TO_ICON, POINTS_RESOURCES } from "Components/Loyalty/EventUtils";
import { useDelayedValue } from "Hooks/useDelayedValue";
import { Resources, useResource } from "Translations/Resources";

const RESOURCES = Resources.Pages.Content.Loyalty.Events;

type Props = {
  event: LoyaltyEventCode;
  points: number;
  progressPercent?: number;
  isCompleted?: boolean;
  loyaltyPointType?: LoyaltyPointType;
};

export const CardChallenge = ({
  event,
  points,
  progressPercent = 0,
  isCompleted = false,
  loyaltyPointType = LoyaltyPointType.Stardust,
}: Props) => {
  const { t } = useResource();
  const animatedProgress = useDelayedValue({ value: progressPercent });

  const icon = EVENT_TO_ICON[event];
  const title = t(RESOURCES[event].title);
  const description = t(RESOURCES[event].description);
  const progress = isCompleted ? 100 : (animatedProgress ?? 0);
  const pointsText = t(POINTS_RESOURCES[loyaltyPointType], {
    count: points,
  });

  return (
    <Stack
      px={3}
      pt={4}
      pb={6}
      mb={2}
      gap={4}
      borderRadius={2}
      alignItems="center"
      justifyContent="space-between"
      boxShadow="0px 1px 5px 0px rgba(0, 0, 0, 0.20)"
      bgcolor="common.white"
      position="relative"
      height="100%"
    >
      <Stack gap={2}>
        <Icon icon={icon} isCompleted={isCompleted} />
        <Title title={title} isCompleted={isCompleted} />
      </Stack>
      <Description description={description} />
      <Points points={pointsText} />
      <Progress progressPercent={progress} />
    </Stack>
  );
};
